import axios from "../lib/axios";
import React from "react";
import { useSelector } from "react-redux";

const AffirmCheckout = ({ onSuccess }) => {
	const { cartItems, shippingAddress, cartSummary } = useSelector(
		(state) => state.cart
	);
	const { userInfo } = useSelector((state) => state.userLogin);
	const country = useSelector((state) => state.country);
	const [sdkReady, setSdkReady] = React.useState(false);
	const items = cartItems.map((item) => {
		return {
			display_name: item.productInfo?.Program,
			sku: "",
			unit_price: parseInt(
				country == "Canada"
					? item.optionInfo?.OUR_PRICE
					: (item.optionInfo?.OUR_PRICE * 0.75).toFixed(2)
			),
			qty: item.optionInfo?.quantity,
			item_url: `https://www.offcutshades.com/shop/${
				item.productInfo.Fabric_Type
			}/${encodeURI(item.productInfo.Program.replaceAll(" ", "_"))}?color=${
				item.productInfo?.SG_Color
			}`,
			image_url: `https://www.offcutshades.com/images/programs/${item.productInfo.Program}/render/${item.productInfo?.SG_Color}+.jpg`,
		};
	});

	let total = country == "USA" ? cartSummary?.TOTAL * 0.75 : cartSummary?.TOTAL;

	let province = shippingAddress?.province.toLowerCase();
	let taxRate = 0;
	switch (province) {
		case "ontario":
			taxRate = 0.13;
			break;
		case "on":
			taxRate = 0.13;
			break;
		case "alberta":
			taxRate = 0.05;
			break;
		case "ab":
			taxRate = 0.05;
			break;
		case "british colombia":
			taxRate = 0.12;
			break;
		case "bc":
			taxRate = 0.12;
			break;
		case "manitoba":
			taxRate = 0.12;
			break;
		case "mb":
			taxRate = 0.12;
			break;
		case "quebec":
			taxRate = 0.14975;
			break;
		case "qc":
			taxRate = 0.14975;
			break;
		case "al":
			taxRate = 0.04;
			break;
		case "ak":
			taxRate = 0;
			break;
		case "az":
			taxRate = 0.056;
			break;
		case "ar":
			taxRate = 0.065;
			break;
		case "ca":
			taxRate = 0.0725;
			break;
		case "co":
			taxRate = 0.029;
			break;
		case "ct":
			taxRate = 0.0635;
			break;
		case "de":
			taxRate = 0;
			break;
		case "dc":
			taxRate = 0.06;
			break;
		case "fl":
			taxRate = 0.06;
			break;
		case "ga":
			taxRate = 0.04;
			break;
		case "hi":
			taxRate = 0.04;
			break;
		case "id":
			taxRate = 0.06;
			break;
		case "il":
			taxRate = 0.0625;
			break;
		case "in":
			taxRate = 0.07;
			break;
		case "ia":
			taxRate = 0.06;
			break;
		case "ks":
			taxRate = 0.065;
			break;
		case "ky":
			taxRate = 0.06;
			break;
		case "la":
			taxRate = 0.0445;
			break;
		case "me":
			taxRate = 0.055;
			break;
		case "md":
			taxRate = 0.06;
			break;
		case "ma":
			taxRate = 0.0625;
			break;
		case "mi":
			taxRate = 0.06;
			break;
		case "mn":
			taxRate = 0.06875;
			break;
		case "ms":
			taxRate = 0.07;
			break;
		case "mo":
			taxRate = 0.04225;
			break;
		case "mt":
			taxRate = 0;
			break;
		case "ne":
			taxRate = 0.055;
			break;
		case "nv":
			taxRate = 0.0685;
			break;
		case "nh":
			taxRate = 0;
			break;
		case "nj":
			taxRate = 0.06625;
			break;
		case "nm":
			taxRate = 0.05125;
			break;
		case "ny":
			taxRate = 0.04;
			break;
		case "nc":
			taxRate = 0.0475;
			break;
		case "nd":
			taxRate = 0.05;
			break;
		case "oh":
			taxRate = 0.0575;
			break;
		case "ok":
			taxRate = 0.045;
			break;
		case "or":
			taxRate = 0;
			break;
		case "pa":
			taxRate = 0.06;
			break;
		case "ri":
			taxRate = 0.07;
			break;
		case "sc":
			taxRate = 0.06;
			break;
		case "sd":
			taxRate = 0.045;
			break;
		case "tn":
			taxRate = 0.07;
			break;
		case "tx":
			taxRate = 0.0625;
			break;
		case "ut":
			taxRate = 0.047;
			break;
		case "vt":
			taxRate = 0.06;
			break;
		case "va":
			taxRate = 0.043;
			break;
		case "wa":
			taxRate = 0.065;
			break;
		case "wv":
			taxRate = 0.06;
			break;
		case "wi":
			taxRate = 0.05;
			break;
		case "wy":
			taxRate = 0.04;
			break;
		default:
			taxRate = 0.15;
	}

	const val = Number(total);
	let tax = (val * taxRate).toFixed(2);
	total = (Number(total) + Number(tax)).toFixed(2);

	// Convert from string to Rounded integer
	tax = Math.round(tax);

	total = total.replace(".", "");

	const handleCheckout = () => {
		try {
			// Checkout object
			let checkout = null;
			if (country === "Canada") {
				checkout = {
					merchant: {
						user_cancel_url: "https://offcutshades.com/placeorder",
						user_confirmation_url: "https://offcutshades.com/confirmation",
						user_confirmation_url_action: "POST",
						name: "Off Cut Shades",
					},
					billing: {
						name: {
							first: shippingAddress?.firstName,
							last: shippingAddress?.lastName,
						},
						address: {
							street1: shippingAddress?.addressLine1,
							street2: shippingAddress?.addressLine2 ? undefined : "",
							city: shippingAddress?.city,
							region1_code: shippingAddress?.province,
							postal_code: shippingAddress?.postalCode,
							country: shippingAddress?.country,
						},
						phone_number: shippingAddress?.phoneNumber,
						email: userInfo?.email,
					},
					shipping: {
						name: {
							first: shippingAddress?.firstName,
							last: shippingAddress?.lastName,
						},
						address: {
							street1: shippingAddress?.addressLine1,
							street2: shippingAddress?.addressLine2 ? undefined : "",
							city: shippingAddress?.city,
							region1_code: shippingAddress?.province,
							postal_code: shippingAddress?.postalCode,
							country: shippingAddress?.country,
						},
						phone_number: shippingAddress?.phoneNumber,
						email: userInfo?.email,
					},
					items: items,
					shipping_amount: 0,
					tax_amount: tax,
					total: total,
					currency: "CAD",
					metadata: {
						mode: "modal",
					},
				};
			} else {
				checkout = {
					merchant: {
						user_cancel_url: "https://offcutshades.com/placeorder",
						user_confirmation_url: "https://offcutshades.com/confirmation",
						user_confirmation_url_action: "POST",
						name: "Off Cut Shades",
					},
					billing: {
						name: {
							first: shippingAddress?.firstName,
							last: shippingAddress?.lastName,
						},
						address: {
							line1: shippingAddress?.addressLine1,
							line2: shippingAddress?.addressLine2 ? undefined : "",
							city: shippingAddress?.city,
							state: shippingAddress?.province,
							zipcode: shippingAddress?.postalCode,
							country: shippingAddress?.country,
						},
						phone_number: shippingAddress?.phoneNumber,
						email: userInfo?.email,
					},
					shipping: {
						name: {
							first: shippingAddress?.firstName,
							last: shippingAddress?.lastName,
						},
						address: {
							line1: shippingAddress?.addressLine1,
							line2: shippingAddress?.addressLine2 ? undefined : "",
							city: shippingAddress?.city,
							state: shippingAddress?.province,
							zipcode: shippingAddress?.postalCode,
							country: shippingAddress?.country,
						},
						phone_number: shippingAddress?.phoneNumber,
						email: userInfo?.email,
					},
					items: items,
					shipping_amount: 0,
					tax_amount: tax,
					total: total,
					currency: "USD",
					metadata: {
						mode: "modal",
					},
				};
			}

			console.log(checkout);

			window.affirm.checkout(checkout);
			window.affirm.checkout.open({
				onFail: function (error) {
					console.log(error);
					alert("Your payment has been failed. Please try again.");
				},
				onSuccess: function (a) {
					console.log("onSuccess, checkout token is: " + a.checkout_token);
					axios
						.post("orders/authorise", {
							token: a.checkout_token,
						})
						.then((res) => {
							if (res.data.status === "authorized") {
								const paymentResult = {
									status: "COMPLETED",
									id: a.checkout_token,
									payer: {
										email_address: userInfo?.email,
										name: {
											given_name: shippingAddress?.firstName,
											surname: shippingAddress?.lastName,
										},
									},
									purchase_units: [
										{
											amount: {
												currency_code: "CAD",
												value: total,
											},
										},
									],
								};
								console.log(paymentResult);
								onSuccess(paymentResult);
							}
						})
						.catch((err) => {
							console.log(err);
							return err;
						});
				},
				onOpen: function (token) {
					console.log(
						"Affirm modal was opened successfully, checkout token is: " + token
					);
				},
				onValidationError: function (a) {
					console.log("onValidationError, respond to bad data here", a);
				},
			});
		} catch (error) {
			console.log(error);
		}
	};

	const addAffirmScript = async () => {
		const script = document.createElement("script");
		script.type = "text/javascript";
		// Using dynamic ENV variables to determine which Affirm API to use -Omar
		script.src = `https://cdn1${
			process.env.NODE_ENV === "production" ? "" : "-sandbox"
		}.affirm.ca/js/v2/affirm.js`;
		script.async = true;
		script.onload = () => {
			window._affirm_config = {
				public_api_key:
					// Using dynamic ENV variables to determine which Affirm API to use -Omar
					process.env.NODE_ENV === "production"
						? process.env.REACT_APP_AFFIRM_PUBLIC_KEY
						: process.env.REACT_APP_AFFIRM_PUBLIC_KEY_SANDBOX,
				locale: "en_CA",
				country_code: "CAN",
			};

			window.affirm.ui.ready(function () {
				console.log("affirm ready");
				setSdkReady(true);
			});
		};
		document.body.appendChild(script);
	};

	if (!window.affirm && !sdkReady) {
		addAffirmScript();
		console.log("affirm loading");
	}

	return (
		sdkReady && (
			<div
				style={{ textAlign: "center", fontSize: "18px", margin: "10px 0" }}
				className="flex flex-col items-center w-full"
			>
				<button
					className="bg-primary text-white rounded-xl px-18 py-4 w-1/2 border-none"
					onClick={() => handleCheckout()}
				>
					Checkout with Affirm
				</button>
				<img
					src="/images/affirm2.png"
					alt="Affirm"
					style={{
						width: "auto",
						height: "50px",
						margin: "auto",
					}}
				/>
			</div>
		)
	);
};

export default AffirmCheckout;
